<template>
  <div style="width: 240px" class="mark">
    <a-menu :defaultSelectedKeys="selectedKeys" :defaultOpenKeys="openKeys" mode="inline" :selectedKeys="selectedKeys"
      :theme="theme" class="my-menu-tag">
      <template v-for="(item, index) in menuData">
        <a-divider style="background: none; margin: 5px 0px 0px 0px" :key="index" />
        <a-menu-item v-if="!item.children" :key="item.path" @click="menuClick(item)">
          <a-icon v-if="item.meta.icon" :type="item.meta.icon" theme="filled" />
          <span v-if="showFlag">{{ getTile(item) }}</span>
        </a-menu-item>

        <sub-menu v-else :menu-info="item" :key="item.path" :showNext="showNext" :lang="$i18n.locale" />
        <a-divider style="margin: 10px 0px 0px 0px" v-if="item.path.toString() != '/setting'" :key="'A' + index" />
      </template>
    </a-menu>
  </div>
</template>

<script>
/*
 * recommend SubMenu.vue https://github.com/vueComponent/ant-design-vue/blob/master/components/menu/demo/SubMenu.vue
 * SubMenu1.vue https://github.com/vueComponent/ant-design-vue/blob/master/components/menu/demo/SubMenu1.vue
 * */
import SubMenu from "./SubMenu";
import homeImg from '@/assets/home_selected.png'
import homeImg2 from '@/assets/home_nor.png'

import { check } from "../utils/auth";
export default {
  name: 'SlideMenu',
  props: {
    theme: {
      type: String,
      default: "dark"
    },
    showFlag: Boolean
  },
  components: {
    SubMenu
  },
  mounted() {
    const mdata = JSON.parse(localStorage.getItem("menu"));
    this.menuData = this.getMenuData(mdata);
     const pathArr = this.$route.path.split('/');
    this.selectedKeys = [this.$route.path];
    this.openKeys = pathArr.length ? ['/' + pathArr[1]] : [];
  },
  watch: {
    "$route.path": {
      handler(val) {
        const pathArr = val.split('/')
        this.selectedKeys = [val];
        this.openKeys = pathArr.length ? ['/' + pathArr[1]] : [];
        console.log(this.selectedKeys, this.openKeys)
      },
      immediately: true
    },
    showFlag: {
      handler(n, o) {
        this.showNext = o;
      },
      deep: true
    }
  },
  data() {
    this.selectedKeysMap = {};
    this.openKeysMap = {};
    return {
      home: homeImg,
      home2: homeImg2,
      collapsed: false,
      showNext: true,
      menuData: [],
      selectedKeys: this.selectedKeysMap[this.$route.path],
      // openKeys: this.collapsed ? [] : this.openKeysMap[this.$route.path]
      openKeys: ["/audience"] //默认展开
    };
  },

  methods: {
    getTitle(item) {
      const curLocale = this.$i18n.locale.split("-")[0];
      switch (curLocale) {
        case "zh":
          return item.meta.title;
        case "en":
          return item.meta.title_en;
        default:
          return item.meta.title_en;
      }
    },
    menuClick(item) {
      if (item.path == "/homeAnalysis") {
        this.home2 = homeImg;

      } else {
        this.home2 = homeImg;
      }
      this.$router.push({ path: item.path, query: this.$route.query });
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    getMenuData(routes = [], parentKeys = [], selectedKey) {
      const menus = [];

      if (routes.length) {
        for (let item of routes) {
          if (item.meta && !item.meta.isHide) {
            this.openKeysMap[item.path] = parentKeys;
            this.selectedKeysMap[item.path] = [selectedKey || item.path];
            const newItem = { ...item };//等价于Object.asign()
            delete newItem.children;
            if (item.children && !item.hideChildrenInMenu) {
              newItem.children = this.getMenuData(item.children, [
                ...parentKeys,
                item.path
              ]);
            } else {
              this.getMenuData(
                item.children,
                selectedKey ? parentKeys : [...parentKeys, item.path],
                selectedKey || item.path
              );
            }
            menus.push(newItem);
          } else if (
            item.meta && !item.meta.isHide &&
            !item.hideChildrenInMenu &&
            item.children
          ) {
            menus.push(
              ...this.getMenuData(item.children, [...parentKeys, item.path, item.showNext = this.showFlag])
            );
          }
        }
        return menus;
      }
      else {
        return []
      }
    }
  }
};
</script>

<style scoped>
.mark ul {
  background-color: white !important;
  margin-bottom: 0px;
  border: none;
}

.mark ul li {
  margin-bottom: 0px;
  margin-top: 5px;
}

/*针对二级菜单过滤,只对有二级菜单选中的处理*/
::v-deep .ant-menu-sub>.ant-menu-item-selected {
  border: none;
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-family: PingFangSC;
  /*background-image: linear-gradient(to right, #FFBE00, #F9A53D, #FFBC0D,#FFBE00, #FEC750);background-image: linear-gradient(to right, #FFED5D, #FEC750, #F9A53D, #FFBC0D, #FEC750, #FFED5D);*/
  background: var(--main-color);
}

.ant-menu-item:hover,
.ant-menu-item-active,
.ant-menu:not(.ant-menu-inline) .ant-menu-submenu-open,
.ant-menu-submenu-active,
.ant-menu-submenu-title:hover {
  color: var(--font-color);
  font-weight: 700;
  font-family: PingFangSC;
  background: var(--main-color);
  /*background-image: linear-gradient(to right, #FFBE00, #F9A53D, #FFBC0D,#FFBE00, #FEC750);*/
}

::v-deep.ant-menu-item::after {
  border: none;
}

/*一级菜单选中处理*/
::v-deep.ant-menu-submenu-selected {
  color: rgba(0, 0, 0, 0.85);
  /* background-image: linear-gradient(to right, #FFBE00, #F9A53D, #FFBC0D,#FFBE00, #FEC750);background-image: linear-gradient(to right, #FFED5D, #FEC750, #F9A53D, #FFBC0D, #FEC750, #FFED5D); */
  border: none;
}

/*二级菜单悬浮样式*/
::v-deep .ant-menu-item-active {
  color: var(--font-color);
  background: var(--main-color);
}

/*一级菜单悬浮样式*/
::v-deep .ant-menu-submenu-active {
  color: black;
}

::v-deep .ant-menu-sub-open {
  color: black;
}

::v-deep .ant-menu-submenu-title:hover {
  color: var(--font-color);
  background: var(--main-color)
}

::v-deep .ant-menu-sub>.ant-menu-item-selected {
  color: var(--font-color);
}

.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title {
  /*width: calc(100% + 10px);*/
  width: 240px;
}
</style>
